const collegeBenefits = [
  {
    title: 'Official Industry Partnership',
    description:
      'Establish a strategic partnership with BPS Group to strengthen industry-academia collaboration.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
        <path d="M4 20V10h5v10M9 20V6h6v14M15 20V9h5v11M3 20h18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: 'Enhanced Placement Outcomes',
    description:
      'Improve graduate employability through structured, industry-aligned career programs.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
        <path d="M4 18l5-5 3 3 7-8M14 8h5v5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: 'Campus Recruitment Support',
    description:
      'Access dedicated recruitment drives and hiring opportunities for eligible students.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
        <circle cx="9" cy="8" r="3" stroke="currentColor" strokeWidth="1.8" />
        <path d="M3 19c0-3.314 2.686-6 6-6s6 2.686 6 6M16 10l2 2 4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: 'Stronger Institutional Brand',
    description:
      "Enhance your college's reputation with premium career accelerator programs.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
        <path d="M12 3l7 4v5c0 4.418-3.134 8.209-7 9-3.866-.791-7-4.582-7-9V7l7-4z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        <path d="M12 8l1.2 2.4 2.6.4-1.9 1.8.5 2.6L12 14.2 9.6 15.6l.5-2.6-1.9-1.8 2.6-.4L12 8z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: 'Workshops & Industry Engagement',
    description:
      'Conduct expert sessions, seminars, hackathons, finance conclaves, and technology events on campus.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
        <path d="M5 19V9a2 2 0 012-2h10a2 2 0 012 2v10M3 19h18M12 7V4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <circle cx="12" cy="13" r="2" stroke="currentColor" strokeWidth="1.8" />
      </svg>
    ),
  },
  {
    title: 'Training & Placement Cell Support',
    description:
      'Continuous collaboration with the T&P Cell for planning, execution, and student career initiatives.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
        <circle cx="8" cy="9" r="2.5" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="16" cy="9" r="2.5" stroke="currentColor" strokeWidth="1.8" />
        <path d="M3 19c0-2.761 2.239-5 5-5h1c1.2 0 2.3.4 3.2 1.1M13 14c.9-.7 2-1.1 3.2-1.1h.8c2.761 0 5 2.239 5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: 'Long-Term Strategic Partnership',
    description:
      'Build a sustainable relationship with ongoing academic and industry support.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
        <path d="M8 12c-2-2-2.5-4.5-1-6s4-1 6 1l1 1 1-1c2-2 4.5-2.5 6-1s1 4-1 6l-6 6-6-6z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: 'Outcome-Driven Career Ecosystem',
    description:
      'Create an ecosystem that strengthens placements, industry exposure, and institutional growth.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
        <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="12" cy="12" r="1.5" fill="currentColor" />
      </svg>
    ),
  },
];

const stats = [
  { value: '1000+', label: 'Students Trained' },
  { value: '50+', label: 'Industry Partners' },
  { value: '8+', label: 'Years of Excellence' },
  { value: 'Big 4', label: 'Leadership Experience' },
];

function Benefits() {
  return (
    <section id="benefits" className="bg-brand-white py-6 lg:py-10">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
        <div className="overflow-hidden rounded-3xl shadow-[0_24px_60px_-32px_rgba(17,22,44,0.4)]">
          {/* Banner with provided split image */}
          <div className="relative lg:min-h-[640px]">
            <img
              src="/images/benefits-bg.png"
              alt="College campus partnership"
              className="absolute inset-0 hidden h-full w-full object-cover object-right lg:block"
            />

            <div className="relative z-10 flex h-full items-center lg:min-h-[640px]">
              <div className="w-full bg-[#002D72] px-5 py-10 sm:px-8 lg:max-w-[58%] lg:bg-transparent lg:px-12 lg:py-12">
                <p className="mb-2 text-label font-semibold uppercase tracking-[0.18em] text-sky-300">
                  What Your Institution Gains
                </p>
                <h2 className="text-[24px] font-bold uppercase leading-tight tracking-wide text-brand-white sm:text-[28px] lg:text-[32px]">
                  Benefits For Colleges
                </h2>
                <p className="mt-3 max-w-md text-body-sm text-brand-white/85">
                  Partner with FutureLeadX and build a future-ready campus ecosystem.
                </p>

                <ul className="mt-8 grid gap-4 sm:grid-cols-2">
                  {collegeBenefits.map((benefit) => (
                    <li key={benefit.title} className="flex gap-3">
                      <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-white/15 text-brand-white">
                        {benefit.icon}
                      </div>
                      <div>
                        <p className="text-body-sm font-semibold text-brand-white">
                          {benefit.title}
                        </p>
                        <p className="mt-0.5 text-label-sm leading-relaxed text-brand-white/75">
                          {benefit.description}
                        </p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Stats bar */}
          {/* <div className="grid grid-cols-2 gap-px bg-brand-navy/40 sm:grid-cols-4">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="flex flex-col items-center justify-center bg-brand-navy px-4 py-5 text-center"
              >
                <p className="text-[28px] font-bold text-brand-white sm:text-[32px]">{stat.value}</p>
                <p className="mt-1 text-label text-brand-white/75">{stat.label}</p>
              </div>
            ))}
          </div> */}
        </div>
      </div>
    </section>
  );
}

export default Benefits;
